'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var HelpArticleTagMain = /** @class */function () {
    function HelpArticleTagMain() {
        this.pathName = decodeURIComponent(window.location.pathname);
        this.currentPage = articleList.current_page;
        this.pageSize = articleList.per_page;
        this.dataTotal = articleList.total;
        this.pageTotal = articleList.last_page;
        this.init();
    }
    HelpArticleTagMain.prototype.init = function () {
        this.logic();
    };
    HelpArticleTagMain.prototype.logic = function () {
        var that = this;
        new Pagination({
            element: '#pagination',
            type: 2,
            layout: 'prev, pager, next, jumper',
            pageIndex: that.currentPage,
            pageSize: that.pageSize,
            pageCount: 7,
            total: that.dataTotal,
            singlePageHide: true,
            ellipsis: true,
            disabled: true,
            currentChange: function currentChange(index) {
                if (index == 1) {
                    window.location.href = "/tags/".concat(tagName);
                } else {
                    window.location.href = "/tags/".concat(tagName, "/list_").concat(index, ".html");
                }
            }
        });
    };
    return HelpArticleTagMain;
}();
exports.default = HelpArticleTagMain;